<mat-dialog-content>
  <div class="container simple">
    <h1>Als Reporter bewerben</h1>
    <p>Damit du Spiele tickern kannst, musst du bitte noch deinen Vor- und Nachnamen eingeben.</p>
    <h2>Dein Name</h2>
    <form [formGroup]="form" (submit)="onSubmit()">
      <mat-form-field hideRequiredMarker class="large" color="primary">
        <mat-label>Vorname</mat-label>
        <input
          required
          matInput
          type="text"
          name="firstName"
          formControlName="firstName"
          autocomplete="given-name"
          placeholder="Vorname" />
      </mat-form-field>
      <mat-form-field hideRequiredMarker class="large" color="primary">
        <mat-label>Nachname</mat-label>
        <input
          matInput
          type="text"
          name="lastName"
          formControlName="lastName"
          autocomplete="family-name"
          placeholder="Nachname" />
      </mat-form-field>
    </form>
    <button (click)="onSubmit()" [disabled]="nextButtonDisabled">Weiter</button>
  </div>
<mat-dialog-content>
